import * as L from "leaflet";
import { IBoundLayerOptions, IBoundLayer } from "../../BoundLayer";
import { getGeolocationState } from "../../../redux/rootReducer";
import { style } from "typestyle";
import { STATE_CHASING } from "../../../redux/modules/geolocation/reducer";
import { blue } from "../../../react/Generics/_colors";
import { userDragsMap } from "./scenarios";

export default class GeolocationLayer extends L.LayerGroup
  implements IBoundLayer {
  public options: IBoundLayerOptions;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
  }

  public onAdd(map: L.Map) {
    L.LayerGroup.prototype.onAdd.call(this, map);
    this.map = map;
    this.map.on("dragend", this.handleDragEnd);
    return this;
  }

  public onRemove(map: L.Map) {
    L.LayerGroup.prototype.onRemove.call(this, map);
    this.map.off("dragend", this.handleDragEnd);
    this.map = null;
    return this;
  }

  public update() {
    this.clearLayers();
    const { stateStatus, position } = getGeolocationState(
      this.options.getState(),
    );
    if (!position) {
      return;
    }

    this.addLayer(
      L.marker(position, {
        icon: L.divIcon({
          className: markerCN,
        }),
      }),
    );
    if (stateStatus === STATE_CHASING) {
      this.map.panTo(position);
    }
  }

  private handleDragEnd = () => {
    this.options.dispatch(userDragsMap());
  };
}

const markerCN = style({
  height: "18px",
  width: "18px",
  border: "2px solid #FFFFFF",
  borderRadius: "100px",
  backgroundColor: blue,
  boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
});
